<template>
  <span>
    <template v-if="categoryName">
      <translate
        v-if="distance && searchPlace"
        :tt="{ count, categoryName, distance, searchPlace }"
      >
        {count} available site with {categoryName} within {distance} of
        {searchPlace}
      </translate>
      <translate
        v-else-if="distance && isUserLocationSearch"
        :tt="{ count, categoryName, distance }"
        >{count} available site with {categoryName} within {distance} of your
        location</translate
      >
      <translate
        v-else-if="hierarchyName"
        :tt="{ count, categoryName, hierarchyName }"
      >
        {count} available site with {categoryName} in {hierarchyName}
      </translate>
      <translate v-else :tt="{ count, categoryName }"
        >{count} available site with {categoryName}</translate
      >
    </template>
    <template v-else>
      <translate
        v-if="distance && searchPlace"
        :tt="{ count, distance, searchPlace }"
        >{count} available site within {distance} of {searchPlace}</translate
      >
      <translate
        v-else-if="distance && isUserLocationSearch"
        :tt="{ count, distance, isUserLocationSearch }"
        >{count} available site within {distance} of your location</translate
      >
      <translate v-else-if="hierarchyName" :tt="{ count, hierarchyName }"
        >{count} available site in {hierarchyName}</translate
      >
      <translate v-else :tt="{ count }">{count} available site</translate>
    </template>
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class SearchSummaryAvailabilitySearch extends Vue {
  @Prop()
  count: number

  @Prop()
  bookableCount: number

  @Prop()
  distance: object

  @Prop()
  searchPlace: string

  @Prop()
  hierarchyName: string

  @Prop()
  categoryName: string

  @Prop()
  isUserLocationSearch: boolean
}

export default toNative(SearchSummaryAvailabilitySearch)
</script>
